import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15937 16628"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#000;stroke-width:1222.68}.fil0{fill:#322d2c}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970273035456">
        <path
          d="M4364 16068c-557 0-946-295-946-561v-949h1892v949c0 266-389 561-946 561zm7118 0c-558 0-946-295-946-561v-949h1891v949c0 266-388 561-945 561zm3500-2070H955c-218 0-395-185-395-412 0-228 177-413 395-413h14027c218 0 395 185 395 413 0 227-177 412-395 412zM11600 3486l774 5212c20 137 138 239 277 239h1089c166 94 743 488 955 1508 265 1280 341 1644 362 2172-24-2-50-4-75-4H955c-74 0-145 9-214 25 20-539 94-896 364-2193 211-1019 788-1414 954-1508h1089c140 0 257-101 278-239l774-5212h7400zM10550 420v2612H9398V1516c0-115-94-209-211-209H7346V420h3204zM5640 1727h3337v1233H5640V1727zM1992 8377c-39 0-78 7-112 23-42 18-1019 461-1324 1931-337 1624-378 1829-382 2697-109 158-174 350-174 558 0 536 428 972 955 972h1903v949c0 629 661 1121 1506 1121s1506-492 1506-1121v-949h4105v949c0 629 662 1121 1507 1121 844 0 1506-492 1506-1121v-949h1994c527 0 955-436 955-972 0-285-121-540-313-718-10-740-65-1018-381-2537-305-1470-1282-1913-1324-1931-35-16-73-23-112-23h-914l-94-632h459c193 0 350-156 350-350 0-193-157-350-350-350h-563l-576-3880c-21-138-138-239-278-239h-870V210c0-116-95-210-211-210H7136c-117 0-210 94-210 210v1097H5430c-116 0-210 94-210 209v1410H3958c-139 0-257 101-277 239l-587 3950h-658c-154 0-280 126-280 280 0 155 125 281 280 281h575l-104 701h-915z"
          className="fil0"
        />
        <path
          d="m7689 4744-4 611h-780c-78 0-136-8-136 69v572c0 78 68 262 146 262h2242c78 0 133-184 133-262l1-572c0-77-39-49-117-49l-82 7-179 3-175-3h-350v-638h2359l359 3251H4761l359-3251h2569zm513 540-148 118-153-125v-455l301 6v456zm-373 280h1181l7 441H7056l-7-441h780zM4448 8556h6970c80 0 156-34 209-93 54-60 78-139 70-218l-420-3812c-16-142-136-249-279-249H4869c-143 0-263 107-279 249l-420 3812c-8 79 16 158 70 218 53 59 128 93 208 93z"
          className="fil0"
        />
        <path
          d="M11648 10352c203 0 369 166 369 369s-166 369-369 369-369-166-369-369 166-369 369-369zm-612 369c0 337 275 611 612 611s611-274 611-611-274-611-611-611-612 274-612 611zM4468 11090c-203 0-368-166-368-369s165-369 368-369c204 0 369 166 369 369s-165 369-369 369zm0-980c-337 0-611 274-611 611s274 611 611 611 612-274 612-611-275-611-612-611z"
          className="fil1 stroke1"
          style={{
            strokeWidth: 1222.68,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
